$(document).on("click",".product-customize-btn",function() {
  $('.embroidery-modals-wrapper').addClass('active');
});

$(document).on("click",".action-close, .embroidery-modals-overlay",function() {
  $('.embroidery-modals-wrapper').removeClass('active');
});
 

 var $embroidery_text_checked = $('#embroidery_text_checked');
 var $embroidery_logo_checked = $('#embroidery_logo_checked');
 var $configAddLogoLine       = $('#configAddLogoLine');
 var $configRemoveLogoline    = $('#configRemoveLogoline');
 var $logo_config_content     = $('#logo_config_content');
 var $configLogoUpload1       = $('#configLogoUpload1');
 var $configLogoUpload2       = $('#configLogoUpload2');
 var $addToCartBtn		      = $('.add-to-cart');
 var $productForm		      = $('.product-purchase-form');
 var $input_text_add          = $('#input_text_add');
 var $input_text_remove       = $('#input_text_remove');
 var $text_line               = $('#text_line');
 var $Logo1selected           = $('input[name="logo[Logo 1 Selected]"]');
 var $Logo2selected           = $('input[name="logo[Logo 2 Selected]"]');

$embroidery_logo_checked.on('change', function() {
  if ($(this).is(':checked')) {
    $(this).parents('.logo-embroidery-block').addClass('active');
  } else {
    $('#submit_embroidery').next('label').text('APPLY MY CUSTOMISATIONS');
    $(this).parents('.logo-embroidery-block').removeClass('active');
  }
});

$embroidery_text_checked.on('change', function() {
  if ($(this).is(':checked')) {
    $(this).parents('.text-embroidery-block').addClass('active');
  } else {
    $('#submit_embroidery').next('label').text('APPLY MY CUSTOMISATIONS');
    $(this).parents('.text-embroidery-block').removeClass('active');
  }
});

$configAddLogoLine.on('click', function() {
  var $logoAdded = $logo_config_content.find('.config-logo-row');

  if(p_type == 'Hat'){
    var nextlogohtml = '<div class="config-logo-row"><div class="input-group"><div class="input-group-logo-seaarch"><input name="logo_search" type="text" placeholder="Search Logo" class="logo_search" id="logo' + ($logoAdded.length+1) + '_search"><button id="logo' + ($logoAdded.length+1) + '_search_btn" type="button" class="btn">Search</button></div><div class="search-logo-results" id="search_logo_result' + ($logoAdded.length+1) + '"></div></div><p class="or-divider"><span>OR</span></p><div class="emb-upload-btn-wrapper"><button class="btn btn--file"><img src="//cdn.shopify.com/s/files/1/0032/7722/6093/t/24/assets/icon-upload.svg?v=78924593357374978671614155253"> Upload logo</button><input id="configLogoUpload' + ($logoAdded.length+1) + '" type="file" accept="image/*"  name="properties[Logo Upload ' + ($logoAdded.length+1) + ']" /></div><div class="emb-position-wrapper"><div class="embroidery-heading-small">Position</div><div class="radio-image"><input class="radio-image__radio" id="logo' + ($logoAdded.length+1) + '_position_hat_front" type="radio" name="logo[Logo ' + ($logoAdded.length+1) + ' Position]" value="Hat Front" data-gtm-form-interact-field-id="4"><label class="radio-image__label" for="logo' + ($logoAdded.length+1) + '_position_hat_front" style="background-image: url(//cdn.shopify.com/s/files/1/0032/7722/6093/files/scrub-front.png?v=1659352369);"><span class="radio-image__label-info">Hat Front</span></label></div><div class="radio-image"><input class="radio-image__radio" id="logo' + ($logoAdded.length+1) + '_position_hat_right" type="radio" name="logo[Logo ' + ($logoAdded.length+1) + ' Position]" value="Hat Right" data-gtm-form-interact-field-id="4"><label class="radio-image__label" for="logo' + ($logoAdded.length+1) + '_position_hat_right" style="background-image: url(//cdn.shopify.com/s/files/1/0032/7722/6093/files/scrub-right.png?v=1659352212);"><span class="radio-image__label-info">Hat Right</span></label></div><div class="radio-image"><input class="radio-image__radio" id="logo' + ($logoAdded.length+1) + '_position_hat_left" type="radio" name="logo[Logo ' + ($logoAdded.length+1) + ' Position]" value="Hat Left" data-gtm-form-interact-field-id="4"><label class="radio-image__label" for="logo' + ($logoAdded.length+1) + '_position_hat_left" style="background-image: url(//cdn.shopify.com/s/files/1/0032/7722/6093/files/scrub-left.png?v=1659352212);"><span class="radio-image__label-info">Hat Left</span></label></div><div class="radio-image"><input class="radio-image__radio" id="logo' + ($logoAdded.length+1) + '_position_other" type="radio" name="logo[Logo ' + ($logoAdded.length+1) + ' Position]" value="Other" data-gtm-form-interact-field-id="4"><label class="radio-image__label" for="logo' + ($logoAdded.length+1) + '_position_other" style="background-image: url(//cdn.shopify.com/s/files/1/0032/7722/6093/files/scrub-other.png?v=1659352212);"><span class="radio-image__label-info">Other</span></label></div></div><div class="input-group other-input-group" ><div class="input-group-text"><input id="logo_possition_other' + ($logoAdded.length+1) + '" name="logo[Logo ' + ($logoAdded.length+1) + ' possition note]" type="text" placeholder="Logo ' + ($logoAdded.length+1) + ' position request" class="logo-possition-other" ></div></div></div>';    
  }else{
  var nextlogohtml = '<div class="config-logo-row"><div class="input-group"><div class="input-group-logo-seaarch"><input name="logo_search" type="text" placeholder="Search Logo" class="logo_search" id="logo2_search"><button id="logo' + ($logoAdded.length+1) + '_search_btn" type="button" class="btn">Search</button></div><div class="search-logo-results" id="search_logo_result' + ($logoAdded.length+1) + '"></div></div><p class="or-divider"><span>OR</span></p><div class="emb-upload-btn-wrapper"><button class="btn btn--file"><img src="//cdn.shopify.com/s/files/1/0032/7722/6093/t/24/assets/icon-upload.svg?v=78924593357374978671614155253"> Upload logo</button><input id="configLogoUpload' + ($logoAdded.length+1) + '" type="file" accept="image/*" name="properties[Logo Upload ' + ($logoAdded.length+1) + ']" /></div><div class="emb-position-wrapper"><div class="embroidery-heading-small">Position</div><div class="radio-image"><input class="radio-image__radio" id="logo' + ($logoAdded.length+1) + '_position_left" type="radio" name="logo[Logo ' + ($logoAdded.length+1) + ' Position]" value="Left-hand body" checked="" data-gtm-form-interact-field-id="5"><label class="radio-image__label" for="logo' + ($logoAdded.length+1) + '_position_left" style="background-image: url(//cdn.shopify.com/s/files/1/0032/7722/6093/t/24/assets/chest-left_small.png?v=15119205090897936131614155205);"><span class="radio-image__label-info">Left body</span></label></div><div class="radio-image"><input class="radio-image__radio" id="logo' + ($logoAdded.length+1) + '_position_right" type="radio" name="logo[Logo ' + ($logoAdded.length+1) + ' Position]" value="Right-hand body" data-gtm-form-interact-field-id="2"><label class="radio-image__label" for="logo' + ($logoAdded.length+1) + '_position_right" style="background-image: url(//cdn.shopify.com/s/files/1/0032/7722/6093/t/24/assets/chest-right_small.png?v=54513628438065602851614155206);"><span class="radio-image__label-info">Right body</span></label></div><div class="radio-image"><input class="radio-image__radio" id="logo' + ($logoAdded.length+1) + '_position_sleeve_left" type="radio" name="logo[Logo ' + ($logoAdded.length+1) + ' Position]" value="Sleeve left" data-gtm-form-interact-field-id="3"><label class="radio-image__label" for="logo' + ($logoAdded.length+1) + '_position_sleeve_left" style="background-image: url(//cdn.shopify.com/s/files/1/0032/7722/6093/t/24/assets/sleeve-text-left_small.png?v=29322209198693310151614155315);"><span class="radio-image__label-info">Left sleeve</span></label></div><div class="radio-image"><input class="radio-image__radio" id="logo' + ($logoAdded.length+1) + '_position_sleeve_right" type="radio" name="logo[Logo ' + ($logoAdded.length+1) + ' Position]" value="Sleeve right" data-gtm-form-interact-field-id="4"><label class="radio-image__label" for="logo' + ($logoAdded.length+1) + '_position_sleeve_right" style="background-image: url(//cdn.shopify.com/s/files/1/0032/7722/6093/t/24/assets/sleeve-text-right_small.png?v=17101040535935815581614155315);"><span class="radio-image__label-info">Right sleeve</span></label></div><div class="radio-image"><input class="radio-image__radio" id="logo' + ($logoAdded.length+1) + '_position_backneck" type="radio" name="logo[Logo ' + ($logoAdded.length+1) + ' Position]" value="Back Neck" data-gtm-form-interact-field-id="4"><label class="radio-image__label" for="logo' + ($logoAdded.length+1) + '_position_backneck" style="background-image: url(//cdn.shopify.com/s/files/1/0032/7722/6093/files/backneck.png?v=1659082158);"><span class="radio-image__label-info">Back Neck</span></label></div><div class="radio-image"><input class="radio-image__radio" id="logo' + ($logoAdded.length+1) + '_position_other" type="radio" name="logo[Logo ' + ($logoAdded.length+1) + ' Position]" value="Other" data-gtm-form-interact-field-id="4"><label class="radio-image__label" for="logo' + ($logoAdded.length+1) + '_position_other" style="background-image: url(//cdn.shopify.com/s/files/1/0032/7722/6093/files/other.png?v=1659082158);"><span class="radio-image__label-info">Other</span></label></div></div><div class="input-group other-input-group" ><div class="input-group-text"><input id="logo_possition_other' + ($logoAdded.length+1) + '" name="logo[Logo ' + ($logoAdded.length+1) + ' possition note]" type="text" placeholder="Logo ' + ($logoAdded.length+1) + ' position request" class="logo-possition-other" ></div></div></div>';
  }
  $logo_config_content.append(nextlogohtml);
 
  if(c_tag == ''){
    //c1dataurl = 'https://www.infectious.com.au/search/?q=tag:embroidery_logo&view=embroidery-logo' + ($logoAdded.length+1);
    c1dataurl = 'https://www.infectious.com.au/collections/logos/embroidery_logo?sort_by=title-ascending&view=embroidery-logo' + ($logoAdded.length+1);
  }else{
    //c1dataurl = 'https://www.infectious.com.au/search/?q=tag:embroidery_logo,'+c_tag+'&view=embroidery-logo' + ($logoAdded.length+1);  
     cdataurl = 'https://www.infectious.com.au/collections/logos/embroidery_logo+'+c_tag+'?sort_by=title-ascending&view=embroidery-logo' + ($logoAdded.length+1);
  }
  
  $.ajax({
    cache: false,
    url: c1dataurl,
    xhrFields: { withCredentials: false },
    success: function(result){
      $('#search_logo_result' + ($logoAdded.length+1)).html(result);
    }
  });
  
  $configRemoveLogoline.show();
  if ($logoAdded.length+1 === 3) {
    $configAddLogoLine.hide();
    return false;
  }
 
}); 

 $configRemoveLogoline.on('click', function() {
   var $logoAdded = $logo_config_content.find('.config-logo-row');
   var $lastlogo  = $logoAdded[($logoAdded.length - 1)];

   $lastlogo.remove();
   removeimage('#logo_upload_image2');
   
   
   $configAddLogoLine.show();
   $configRemoveLogoline.show();
   if ($logoAdded.length-1 === 1) { 
     $configAddLogoLine.show();
     $configRemoveLogoline.hide();
     return false;
   }
   
 });

$configLogoUpload1.on('change', function() {
  console.log("changed");
  $('input[name="logo[Logo 1 Selected]"]').prop('checked', false);
  $('#configLogoUpload1').next('#logo1_upload_file').remove();
  $('.submit-embroidery-block').removeClass('active');
  const file1 = this.files[0];
  const  fileType1 = file1['type'];
  const validImageTypes1 = ['image/jpeg', 'image/png'];

if (validImageTypes1.includes(fileType1)) {
$('.submit-embroidery-block').addClass('active');
  if (this.files && this.files[0]) {
    var reader = new FileReader();
    var filename1 = this.files[0].name;
     reader.onload = function(e) {
        var imgrenderhtml1 = '<a id="logo1_upload_file" href="' + e.target.result + '">' + filename1 + '</a>';
       $('#configLogoUpload1').after(imgrenderhtml1);
       
     }
    
    reader.readAsDataURL(this.files[0]); // convert to base64 string
  }
}else{
  alert('Please select jpg or png image');
}
  /*
  removeimage('#logo_upload_image1');
   if (this.files && this.files[0]) {
     var reader = new FileReader();
     
     //console.log(reader);
     reader.onload = function(e) {
     	//$('#logo_upload_image1').attr('src', e.target.result);
        var imgrenderhtml1 = '<div class="visual-logo-call"><img id="logo_upload_image1" src="' + e.target.result + '"></div>';
       $('.visual-logo .visual-logo-row').prepend(imgrenderhtml1);
       
     }
   reader.readAsDataURL(this.files[0]); // convert to base64 string
   }
  */

  
});


$(document).on("change","#configLogoUpload2",function() {
  $('input[name="logo[Logo 2 Selected]"]').prop('checked', false);
  $('#configLogoUpload2').next('#logo2_upload_file').remove();
  $('.submit-embroidery-block').addClass('active');
  const file2 = this.files[0];
  const  fileType2 = file2['type'];
  const validImageTypes2 = ['image/jpeg', 'image/png'];

if (validImageTypes2.includes(fileType2)) {

  if (this.files && this.files[0]) {
    var reader2 = new FileReader();
    var filename2 = this.files[0].name;
     reader2.onload = function(e) {
        var imgrenderhtml2 = '<a id="logo2_upload_file" href="' + e.target.result + '">' + filename2 + '</a>';
       $('#configLogoUpload2').after(imgrenderhtml2);
       
     }
    
    reader2.readAsDataURL(this.files[0]); // convert to base64 string
  }
}else{
  alert('Please select jpg or png image');
}
  /*
  removeimage('#logo_upload_image2');
  
   if (this.files && this.files[0]) {
     var reader1 = new FileReader();
     
     reader1.onload = function(e) {
     	//$('#logo_upload_image2').attr('src', e.target.result);
      	
       var imgrenderhtml2 = '<div class="visual-logo-call"><img id="logo_upload_image2" src="' + e.target.result + '"></div>';
       $('.visual-logo .visual-logo-row').append(imgrenderhtml2);
      
     }
   reader1.readAsDataURL(this.files[0]); // convert to base64 string
   }
  */
  
});

$(document).on("change","#configLogoUpload3",function() {
  $('input[name="logo[Logo 3 Selected]"]').prop('checked', false);
  $('#configLogoUpload3').next('#logo3_upload_file').remove();

  const file3 = this.files[0];
  const  fileType3 = file3['type'];
  const validImageTypes3 = ['image/jpeg', 'image/png'];

if (validImageTypes3.includes(fileType3)) {
  if (this.files && this.files[0]) {
    var reader3 = new FileReader();
    var filename3 = this.files[0].name;
     reader3.onload = function(e) {
        var imgrenderhtml3 = '<a id="logo3_upload_file" href="' + e.target.result + '">' + filename3 + '</a>';
       $('#configLogoUpload3').after(imgrenderhtml3);
       
     }
    
    reader3.readAsDataURL(this.files[0]); // convert to base64 string
  }
}else{
  alert('Please select jpg or png image');
}
});

function removeimage(id){
	 $(id).parent().remove();
}

/*
$(document).on("keyup","#logo1_search",function(e) {
    e.preventDefault();
  	var data = this;
    logo_search(null,data,'embroidery-logo');
});
$(document).on("keyup","#logo2_search",function(e) {
    e.preventDefault();
  	var data = this;
    logo_search(null,data,'embroidery-logo2');
});
*/

$(document).on("click","#logo1_search_btn",function(e) {
    e.preventDefault();
  	var data = this;
    logo_search(null,data,'embroidery-logo');
});
$(document).on("click","#logo2_search_btn",function(e) {
    e.preventDefault();
  	var data = this;
    logo_search(null,data,'embroidery-logo2');
});
$(document).on("click","#logo3_search_btn",function(e) {
    e.preventDefault();
  	var data = this;
    logo_search(null,data,'embroidery-logo3');
});

function logo_search($paginate = null,data,view){
  
  //$('.search-logo-loader').addClass('active');
  
  //var search = $("input[name*='logo_search']").val();
  var search = $(data).prev().val();
  //console.log(search);
  
  if($paginate){
    dataurl = 'https://www.infectious.com.au'+$paginate;
  }else{
    dataurl = 'https://www.infectious.com.au/search/?q=title:'+search+'* AND tag:embroidery_logo&view=' + view;
  }
  
  $.ajax({
    cache: false,
    url: dataurl,
    xhrFields: { withCredentials: false },
    success: function(result){
      $(data).parent().next('.search-logo-results').html(result);
      
      //$('.search-logo-loader').removeClass('active');
    }
  });
  
}

$(document).ready(function() {
  if(c_tag == ''){
    //cdataurl = 'https://www.infectious.com.au/search/?q=tag:embroidery_logo&view=embroidery-logo';
    cdataurl = 'https://www.infectious.com.au/collections/logos/embroidery_logo?sort_by=title-ascending&view=embroidery-logo1';
  }else{
    //cdataurl = 'https://www.infectious.com.au/search/?q=tag:embroidery_logo,'+c_tag+'&view=embroidery-logo';
    cdataurl = 'https://www.infectious.com.au/collections/logos/embroidery_logo+'+c_tag+'?sort_by=title-ascending&view=embroidery-logo1';
  }
  
  $.ajax({
  cache: false,
  url: cdataurl,
  xhrFields: { withCredentials: false },
  success: function(result){
    $('#search_logo_result1').html(result);
  }
  });
});

  $(document).on("click",".pagination-em .page a,.pagination-em .prev a,.pagination-em .next a",function(event) {
    event.preventDefault();
	//var data = $(this).parents('.search-logo-results').prev('.logo_search');
    var data = $(this).parents('.search-logo-results').prev('.input-group-logo-seaarch').children('button');
   	var page = $(this).attr('href');
    logo_search(page,data,null);
  });

$(document).on("click", ".search-logo-results > ul > li > input ", function (e) {
    //e.preventDefault();
    var logoUrl = $(this).data('logo-url');
    var imgrenderhtml = '<img src="' + logoUrl + '" />';
    $('.embroidery-call-left .visual-gif-img').html(imgrenderhtml);
    $('.submit-embroidery-block').addClass('active');
});
/* Preview logo 
  $(document).on("click",".search-logo-results > ul > li > input ",function(e) {
    //e.preventDefault();
    var parent = $(this).parents('.search-logo-results').attr('id');
    var logoUrl = $(this).data('logo-url');

    if ($('.visual-logo .visual-logo-row .visual-logo-call').length > 0) {
         if(parent == 'search_logo_result1'){
           removeimage('#logo_upload_image1');
           var imgrenderhtml = '<div class="visual-logo-call"><img id="logo_upload_image1" src="' + logoUrl + '"></div>';
           $('.visual-logo .visual-logo-row').prepend(imgrenderhtml);
         }else{
           removeimage('#logo_upload_image2');
           var imgrenderhtml = '<div class="visual-logo-call"><img id="logo_upload_image2" src="' + logoUrl + '"></div>';
           $('.visual-logo .visual-logo-row').append(imgrenderhtml);
         }     
    }else{
      var imgrenderhtml = '<div class="visual-logo-call"><img id="logo_upload_image1" src="' + logoUrl + '"></div>';
      $('.visual-logo .visual-logo-row').prepend(imgrenderhtml);
    }

  });
 Preview logo */

$(document).on('click','input[name="logo[Logo 1 Selected]"]',function(e) {
  $configLogoUpload1.val('');
});
$(document).on('click','input[name="logo[Logo 2 Selected]"]',function(e) {
  $('#configLogoUpload2').val('');
});


$input_text_add.on('click', function() {
  var $textline = $text_line.find('#text_line_input input');
  var $textAdded = $text_line.find('#text_line_input');
  
  var nexttexthtml = '<input id="text' + ($textline.length+1) + '" name="" type="text" placeholder="Line ' + ($textline.length+1) + '" class="">';
  $textAdded.append(nexttexthtml);
  
  $input_text_remove.show();
  if ($textline.length+1 === 3) {
    $input_text_add.hide();
    return false;
  }
});

$input_text_remove.on('click', function() {
var $textline = $text_line.find('#text_line_input input');
var $textparent = $text_line.find('#text_line_input');
$textparent.children().last().remove();

  $input_text_add.show();
  if ($textline.length-1 < 2) {
    $input_text_remove.hide();
    return false;
  }
}); 

  function count_down(obj, count){

    let element = document.getElementById('count'+ count);
    let valuelenght = obj.value.length;
    if(valuelenght > 0){
      $('.submit-embroidery-block').addClass('active');
    }else{
       $('.submit-embroidery-block').removeClass('active');
    }
    
    if(valuelenght <= 30){
      $(element).text(valuelenght);
    }else{
       return false;
    }

    
  }

function ajaxAddtoCart(items){
  console.log(items);
  let ajaxstatus;
   $.ajax({
        url: '/cart/add.js',
        cache: false,
        async: false,
        type: 'post',
        dataType: 'json',
        data: { items: items },
        success: function(data, textStatus, jQxhr) {
            //$productForm.find('input[name="properties[Configuration ID]"]').remove();
            //$productForm.prepend('<input type="hidden" name="properties[Configuration ID]" value="'+configId+'" />');
            //$productForm.submit();
              //return data;     
          ajaxstatus = 'success';
        },
        error: function(jqXhr, textStatus, errorThrown) {
          console.log(errorThrown);
          ajaxstatus = 'There was a problem. Please try again';
        }   
   });

  return ajaxstatus;

}

$('#submit_embroidery').on('click', function(evt) {
  var e_validate = true;
  if($embroidery_text_checked.is(':checked') || $embroidery_logo_checked.is(':checked')){
  
    if($embroidery_text_checked.is(':checked')){
      if($('input[name="text[Text Line 1]"]').val() == ''){
        e_validate = false;
        alert("Please add embroidery text");
        return false;
      }else{
        $('.customisation-selected #cs-text').text('Text Embroidery');
        $('.customisation-selected #cs-text').addClass('active');
      }
    }else{
      $('.customisation-selected #cs-text').removeClass('active');
      $('.customisation-selected #cs-text').text('');
    }
    if($embroidery_logo_checked.is(':checked')){
      if(($('input[name="logo[Logo 1 Selected]"]').is(':checked') == false) && ($('#configLogoUpload1').val() == '')){
        e_validate = false; 
        alert("Please, select or upload logo");
        return false;
      }else{
        $('.customisation-selected #cs-logo').text('Logo Embroidery');
        $('.customisation-selected #cs-logo').addClass('active');
      }
    }else{
      $('.customisation-selected #cs-logo').text('');
      $('.customisation-selected #cs-logo').removeClass('active');
    }
    
    if($(this).is(':checked') && e_validate == true){
      $("#loopreturn_lineitem").val("Final Sale");
      $('.embroidery-modals-wrapper').removeClass('active');
      $('#submit_embroidery').next('label').text('ADD TO GARMENT');
    }else{
      $("#loopreturn_lineitem").val("");
      $('.customisation-selected #cs-text').text('');
      $('.customisation-selected #cs-logo').text('');
      $('.customisation-selected #cs-logo').removeClass('active');
      $('.customisation-selected #cs-text').removeClass('active');
      $('#submit_embroidery').next('label').text('ADD TO GARMENT');
      $('.submit-embroidery-block').removeClass('active');
    }
  
  }else{
    $("#loopreturn_lineitem").val("");
    $('.customisation-selected #cs-text').text('');
    $('.customisation-selected #cs-text').removeClass('active');
    $('.customisation-selected #cs-logo').text('');
    $('.customisation-selected #cs-logo').removeClass('active');
    $('.submit-embroidery-block').removeClass('active');
    alert("Please customise item before submit.");
    return false;
  }
  
});


$(document).on("change","#use_color_logo",function() {
	if($(this).is(':checked') == true){
		$('#logo_match_note').parents('.other-input-group').show();
	}else{
		$('#logo_match_note').parents('.other-input-group').hide();
	}
});

$(document).on('change','input[name="text[Text Position]"]',function() {
  if($(this).val() == 'Other'){
    $(this).parents('.emb-position-wrapper').next('.other-input-group').show();
  }else{
    $(this).parents('.emb-position-wrapper').next('.other-input-group').hide();
  }
});
$(document).on('change','input[name="logo[Logo 1 Position]"]',function() {
  if($(this).val() == 'Other'){
    $(this).parents('.emb-position-wrapper').next('.other-input-group').show();
  }else{
    $(this).parents('.emb-position-wrapper').next('.other-input-group').hide();
  }
});
$(document).on('change','input[name="logo[Logo 2 Position]"]',function() {
  if($(this).val() == 'Other'){
    $(this).parents('.emb-position-wrapper').next('.other-input-group').show();
  }else{
    $(this).parents('.emb-position-wrapper').next('.other-input-group').hide();
  }
});
$(document).on('change','input[name="logo[Logo 3 Position]"]',function() {
  if($(this).val() == 'Other'){
    $(this).parents('.emb-position-wrapper').next('.other-input-group').show();
  }else{
    $(this).parents('.emb-position-wrapper').next('.other-input-group').hide();
  }
});

$(document).on('keypress','.logo_search',function(event) {
  if (event.keyCode === 13) {
    event.preventDefault();
    
    var data = $(this).next('.btn');
    logo_search(null,data,'embroidery-logo');
  }
});

$(document).on('change','#SingleOptionSelector-0,#SingleOptionSelector-1',function() {
	$('#embroidery_text_checked').prop('checked', false);
	$('#embroidery_text_checked').parents('.text-embroidery-block').removeClass('active');
	$('#embroidery_logo_checked').prop('checked', false);
	$('#embroidery_logo_checked').parents('.logo-embroidery-block').removeClass('active');
	$('.customisation-selected #cs-text').removeClass('active');
	$('.customisation-selected #cs-text').text('');
	$('.customisation-selected #cs-logo').text('');
	$('.customisation-selected #cs-logo').removeClass('active');
    $('#submit_embroidery').prop('checked', false);
});

$addToCartBtn.on('click', function(evt) {
  evt.preventDefault();
  if($('#submit_embroidery').is(':checked')){
    console.log("submit if");

    var logouploadcart      = false;
    var configId            = Date.now();
    var items               = [];
    var logoselectitems     = [];
    var logo1selectitems    = [];
    var logo2selectitems    = [];
    var textcheked          = $embroidery_text_checked.is(':checked');
    var logochecked         = $embroidery_logo_checked.is(':checked');
    var quantity            = parseInt($('input[name="quantity"]').val());
    
    if (textcheked) {
      console.log('if text checked');
      
      var textLine1 	          = $('input[name="text[Text Line 1]"]').val();
      var textLine2 	          = $('input[name="text[Text Line 2]"]').val();
      var textLine3               = $('input[name="text[Text Line 3]"]').val();
      var textLine4               = $('input[name="text[Text Line 4]"]').val();
      var textLine5               = $('input[name="text[Text Line 5]"]').val();
      var textLine6               = $('input[name="text[Text Line 6]"]').val();
      var textPosition            = $('input[name="text[Text Position]"]:checked').val();
      var textsize                = $('select[name="text[Text Size]"]').val();
      
      if($('input[name="text[Use color match logo]"]').is(':checked') == false){
        var textColour 	          = $('input[name="text[Text Color]"]:checked').val();
      }else{
        var textColour 	          = '';
      }
      var use_color_match_logo 	  = $('input[name="text[Use color match logo]"]:checked').val();
      var text_possition_note 	  = $('input[name="text[Text possition note]"]').val();
      var text_logo_match_note 	  = $('input[name="text[Logo match note]"]').val();
      

      items.push({ 
        id: $embroidery_text_checked.data('text-variant'), 
        quantity: quantity,
        properties: {
          'Configuration ID': configId,
          'Text Line 1': textLine1,
          'Text Line 2': textLine2,
          'Text Line 3': textLine3,
          'Text Line 4': textLine4,
          'Text Line 5': textLine5,
          'Text Line 6': textLine6,
          'Text Colour': textColour,
          'Text Position': textPosition,
          'Text Position Note': text_possition_note,
          'Text Size': textsize,
          'Color match logo': use_color_match_logo,
          'Logo match note': text_logo_match_note,
        }
      });
     /*
      var textAjax = ajaxAddtoCart(items);
      if(textAjax != 'success'){
         alert(textAjax);
      }
      */
          
      $productForm.find('input[name="properties[Configuration ID]"]').remove();
      $productForm.prepend('<input type="hidden" name="properties[Configuration ID]" value="'+configId+'" />');
      
      
    } else {
      console.log('else text unchecked');
    }
    
    if (logochecked) {
      var optupload1 = $configLogoUpload1.val();
      var optupload2 = $('#configLogoUpload2').val();
      var optupload3 = $('#configLogoUpload3').val();
      if(optupload1 != '' && optupload1 != undefined){
         console.log("upload 1 if");
            var logouploadcart = true;
            items.push({ 
              id: 32667884355693, 
              quantity: 1,
              properties: {'Configuration ID': configId }
            });

        var logoPosition1 	  = $('input[name="logo[Logo 1 Position]"]:checked').val();
        var logo1_possition_note 	  = $('input[name="logo[Logo 1 possition note]"]').val();
        
            items.push({ 
              id: $embroidery_logo_checked.data('logo-variant'), 
              quantity: quantity,
              properties: {
              'Configuration ID': configId,
              'Logo 1 Position': logoPosition1,
              'Logo 1 position note': logo1_possition_note,
              }
            });

        
      }else{
        if($('input[name="logo[Logo 1 Selected]"]').is(':checked')){
          console.log("select 1 if");
          var logoPosition1 	  = $('input[name="logo[Logo 1 Position]"]:checked').val();
          var logo_prd1 	  = $('input[name="logo[Logo 1 Selected]"]:checked').val();
          var logo1_possition_note 	  = $('input[name="logo[Logo 1 possition note]"]').val();
    
           items.push({ 
            id: logo_prd1, 
            quantity: quantity,
            properties: {
              'Configuration ID': configId,
              'Logo 1 Position': logoPosition1,
              'Logo 1 position note': logo1_possition_note,
            }
          });
          /*
          var logoAjax1 = ajaxAddtoCart(logo1selectitems);
          if(logoAjax1 != 'success'){
             alert(logoAjax1);
          }
          */
        }
      }
      if(optupload2 != '' && optupload2 != undefined){
        console.log("upload 2 if");
        var logouploadcart = true;
        items.push({ 
          id: 32667884355693, 
          quantity: 1,
          properties: {'Configuration ID': configId }
        });

        var logoPosition2 	  = $('input[name="logo[Logo 2 Position]"]:checked').val();
        var logo2_possition_note 	  = $('input[name="logo[Logo 2 possition note]"]').val();
        
        items.push({ 
          id: $embroidery_logo_checked.data('logo-variant'), 
          quantity: quantity,
          properties: {
          'Configuration ID': configId,
          'Logo 2 Position': logoPosition2,
          'Logo 2 position note': logo2_possition_note,
          }
        });
         
      }else{

         if($('input[name="logo[Logo 2 Selected]"]').is(':checked')){
          console.log("select 2 if");
          var logoPosition2 	  = $('input[name="logo[Logo 2 Position]"]:checked').val();
          var logo_prd2 	  = $('input[name="logo[Logo 2 Selected]"]:checked').val();
           var logo2_possition_note 	  = $('input[name="logo[Logo 2 possition note]"]').val();
    
           items.push({ 
            id: logo_prd2, 
            quantity: quantity,
            properties: {
              'Configuration ID': configId,
              'Logo 2 Position': logoPosition2,
              'Logo 2 position note': logo2_possition_note,
            }
          });
          
          /*
          var logoAjax2 = ajaxAddtoCart(logo2selectitems);
          if(logoAjax2 != 'success'){
             alert(logoAjax2);
          }
          */
        }
         
       }

       if(optupload3 != '' && optupload3 != undefined){
        console.log("upload 3 if");
        var logouploadcart = true;
        items.push({ 
          id: 32667884355693, 
          quantity: 1,
          properties: {'Configuration ID': configId }
        });

        var logoPosition3 	  = $('input[name="logo[Logo 3 Position]"]:checked').val();
        var logo3_possition_note 	  = $('input[name="logo[Logo 3 possition note]').val();
        
        items.push({ 
          id: $embroidery_logo_checked.data('logo-variant'), 
          quantity: quantity,
          properties: {
          'Configuration ID': configId,
          'Logo 3 Position': logoPosition3,
          'Logo 3 position note': logo3_possition_note,
          }
        });
         
      }else{

         if($('input[name="logo[Logo 3 Selected]"]').is(':checked')){
          console.log("select 3 if");
          var logoPosition3 	  = $('input[name="logo[Logo 3 Position]"]:checked').val();
          var logo_prd3 	  = $('input[name="logo[Logo 3 Selected]"]:checked').val();
           var logo3_possition_note 	  = $('input[name="logo[Logo 3 possition note]').val();
    
           items.push({ 
            id: logo_prd3, 
            quantity: quantity,
            properties: {
              'Configuration ID': configId,
              'Logo 3 Position': logoPosition3,
              'Logo 3 position note': logo3_possition_note,
            }
          });
          
          /*
          var logoAjax2 = ajaxAddtoCart(logo2selectitems);
          if(logoAjax2 != 'success'){
             alert(logoAjax2);
          }
          */
        }
         
       }
      
      console.log('if logo checked');
      
      
      /*
      setTimeout(function() { 
         var logoAjax = ajaxAddtoCart(logoselectitems);
      }, 1000);
        */
      $productForm.find('input[name="properties[Configuration ID]"]').remove();
      $productForm.prepend('<input type="hidden" name="properties[Configuration ID]" value="'+configId+'" />');
      
    } else {
     console.log('else logo checked');
    }

  console.log(logouploadcart);
 
  var cartAjax = ajaxAddtoCart(items);
  if(cartAjax != 'success'){
     alert(cartAjax);
  }else{
    if(logouploadcart == true){
       $productForm.submit();
    }else{
        $('.add-to-cart-hide').trigger('click');
        $('#embroidery_text_checked').prop('checked', false);
    	$('#embroidery_text_checked').parents('.text-embroidery-block').removeClass('active');
    	$('#embroidery_logo_checked').prop('checked', false);
    	$('#embroidery_logo_checked').parents('.logo-embroidery-block').removeClass('active');
    	$('.customisation-selected #cs-text').removeClass('active');
    	$('.customisation-selected #cs-text').text('');
    	$('.customisation-selected #cs-logo').text('');
    	$('.customisation-selected #cs-logo').removeClass('active');
        $('#submit_embroidery').prop('checked', false);
    }
  }

    /*
  setTimeout(function() { 
    $productForm.submit();
     $('.add-to-cart-hide').trigger('click');
  }, 2500);
    */

  
  }else{
    console.log("submit else");
     $productForm.find('input[name="properties[Configuration ID]"]').remove();
    $('.add-to-cart-hide').trigger('click');
    //$productForm.submit();  
  }
   
  
});
    